import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { Document, pdf } from '@react-pdf/renderer';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { StructureService } from '../../services/structure_service';
import { VersionshistorieExport } from './VersionshistorieExport';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface VersionshistorieState {
    data: any;
    isLoading: boolean;
    renderPdfButton: JSX.Element;
    showExport: boolean;
}

export class Versionshistorie extends React.Component<{}, VersionshistorieState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
            renderPdfButton: null,
            showExport: false
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    @lazyInject(StructureService) private structureService: StructureService;

    onDataLoaded(data: any[]): void {
        const bereich: any = {};
        const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL_ADMIN, IDs.ENT_VERSIONSHISTORIE) || {};

        (((structure.ATTS || []).find((item: any) => item.KEY === 'bereich') || {}).OPTS || []).forEach((item: any) =>
            item.TITEL && item.VALUE ? bereich[item.VALUE] = item.TITEL : null
        );

        (data || []).forEach((item: any) => {
            item.bereich = bereich[item.bereich] || item.bereich;
        });
        this.setState({ data: { [IDs.ENT_VERSIONSHISTORIE]: data } });
    }

    render(): JSX.Element {
        return <>
            <WFormsTableWrapper
                entity={IDs.ENT_VERSIONSHISTORIE}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={this.renderHeaderElements()}
                columnWidths={[150, 500]}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customCssStyle={{
                    formField: { beschreibung: { styleTextarea: { height: 200 } } }
                }}
                onDataLoaded={this.onDataLoaded}
                showColumnsHelp
            />
            {this.state.showExport && this.renderExport()}
        </>;
    }

    renderExport(): JSX.Element {
        return (
            <div style={{ display: 'none' }}>
                <VersionshistorieExport
                    data={this.state.data}
                    setJSXdirect={(content: JSX.Element) => this.processPdf(content)}
                    setRenderButton={() => null}
                // setRenderButton={(renderButton: JSX.Element) => this.setState({ renderPdfButton: renderButton })}
                />
            </div>
        );
    }

    renderHeaderElements(): JSX.Element[] {
        return [
            <WActionButton
                label='Export'
                insideText='Export'
                tooltip='PDF Export'
                key='pdf'
                action='pdf'
                disabled={!this.state.data}
                onAction={() => this.setState({ isLoading: true, showExport: true })}
            />
        ];
    }

    async processPdf(pdfData: JSX.Element): Promise<void> {
        pdfData = <Document>{pdfData}</Document>;
        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ isLoading: false, showExport: false });
            const filename: string =
                'Versionshistorie' +
                ` [${(new Date()).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}].pdf`;
            // const a = document.createElement('a');
            // a.target = '_blank';
            // a.title = filename;
            // a.href = pdfString;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfString, filename);
        } catch (error) {
            console.log('error: ', error);
        }
    }
}
